export default "__VITE_ASSET__85d61c4a__"